import TagManager from "react-gtm-module";
import { GoogleTagManagerEventType as EventType } from "greenpeace";

declare const gtag: any;

export const initialize = (gtmId: any) => {
  const tagManagerArgs = { gtmId };
  TagManager.initialize(tagManagerArgs);
};

export const pushToDataLayer = (event: EventType) => {
  if (window.dataLayer) {
    window.dataLayer.push({ ...event });
  }
};

/**
 * Obtiene el valor de una cookie por su nombre
 * @param {string} name
 * @returns {string|null}
 */
export function getCookie(name: string) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return null;
}

/**
 * Obtiene el Client ID de GA4
 * @param {string} measurementId - Tu GA4 Measurement ID (ej: G-XXXXXX)
 * @returns {Promise<string>}
 */
export function getGA4ClientId(measurementId: string): Promise<string | null> {
  return new Promise((resolve) => {
    const timeout = setTimeout(() => {
      console.warn("GA4 Client ID request timed out");
      resolve(null);
    }, 3000);

    if (typeof gtag === "function") {
      try {
        gtag("get", measurementId, "client_id", (clientId: string) => {
          clearTimeout(timeout);
          resolve(clientId);
        });
      } catch (e) {
        console.error("Error calling gtag:", e);
        clearTimeout(timeout);
        resolve(null);
      }
    } else {
      clearTimeout(timeout);
      resolve(null);
    }
  });
}

/**
 * Obtiene el valor del session_id desde gtag
 * @param {string} measurementId
 * @returns {Promise<string|null>}
 */
export async function getGA4SessionId(measurementId: string): Promise<string | null> {
  return new Promise((resolve) => {
    const timeout = setTimeout(() => resolve(null), 1000);

    // @ts-ignore
    if (typeof gtag === "function") {
      try {
        gtag("get", measurementId, "session_id", (sessionId: string) => {
          clearTimeout(timeout);
          resolve(sessionId);
        });
      } catch (e) {
        console.error("Error calling gtag for session_id:", e);
        clearTimeout(timeout);
        resolve(null);
      }
    } else {
      clearTimeout(timeout);
      resolve(null);
    }
  });
}

/**
 * Obtiene el valor de _fbc cookie con fallback al parámetro fbclid en la URL
 * @returns {string|null}
 */
export function getFbcCookie(): string | null {
  const cookie = getCookie("_fbc");
  if (cookie) return cookie;

  try {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get("fbclid");
    if (fbclid) {
      return `fb.1.${Date.now()}.${fbclid}`;
    }
  } catch (e) {
    console.error("Error parsing fbclid from URL:", e);
  }
  return null;
}

/**
 * Obtiene todos los datos de tracking necesarios para el backend
 * @param {string} measurementId
 * @returns {Promise<any>}
 */
export async function getTrackingData(measurementId?: string) {
  return {
    ga4_client_id: measurementId ? await getGA4ClientId(measurementId) : null,
    ga4_session_id: measurementId ? await getGA4SessionId(measurementId) : null,
    meta_fbp: getCookie("_fbp"),
    meta_fbc: getFbcCookie(),
    user_agent: navigator.userAgent,
    ip_address: null, // El backend se encargará de obtenerla de la petición
  };
}
